import API from 'services/API';

export default function getServices(query) {
  const faceId = query.faceId || 8; //always 8 for mere mortals
  return API.request({
    method: 'GET',
    url: `/appointment/getServices?fnsId=${query.id}&faceId=${faceId}`,
    mapper: function (data = []) {
      return data;
    },
  });
}
